<div class="counter-sec2 space-top mb-2 d-none d-sm-block">
    <div class="container">
        <div class="row gy-4 align-items-center justify-content-center">

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style2 inner-style">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number text-white">
                            <span class="counter-number">12</span>
                        </h3>
                        <h6 class="counter-title text-white">Years Experience</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style2 inner-style">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number text-white">
                            <span class="counter-number">97</span>%
                        </h3>
                        <h6 class="counter-title text-white">Retention Rate</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style2 inner-style">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number text-white">
                            <span class="counter-number">654</span>+
                        </h3>
                        <h6 class="counter-title text-white">Project Completed</h6>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-3">
                <div class="counter-card style2 inner-style">
                    <div class="counter-shape"><span></span></div>
                    <div class="media-body">
                        <h3 class="box-number text-white">
                            <span class="counter-number">5</span>m
                        </h3>
                        <h6 class="counter-title text-white">Audience Reach</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape-mockup jump d-none d-xl-block" data-bottom="20%" data-left="5%">
        <img src="assets/img/shape/shape_5.png" alt="shape">
    </div>
</div>